import React from 'react';
import { useIntl } from 'react-intl';
import { Select } from '@package/components/Widgets';
import { Container, Pagination } from 'semantic-ui-react';
import paginationLeftSVG from '@plone/volto/icons/left-key.svg';
import paginationRightSVG from '@plone/volto/icons/right-key.svg';
import { Icon } from '@plone/volto/components';
import ProjectsCardListing from '@package/components/Blocks/Listing/variations/ProjectsCardListing';
import messages from './messages';

const PAGE_SIZE = 12;

const List = ({
  items,
  filters,
  setFilters,
  results_region_id,
  visible,
  isEditMode,
  page,
  setPage,
}) => {
  const intl = useIntl();
  const handleQueryPaginationChange = (e, { activePage }) => {
    window.scrollTo(0, 0);
    setPage(activePage);
  };

  return visible ? (
    <div className="list-wrapper">
      <Container>
        <div className="widgets">
          <Select
            classNameWrapper="widget"
            placeholder={intl.formatMessage(messages.sort_on)}
            value={filters.sort_on}
            options={[
              {
                label: intl.formatMessage(messages.filter_bando),
                value: 'titolo_bando',
              },
              {
                label: intl.formatMessage(messages.filter_organizzazione),
                value: 'organizzazione_po',
              },
              {
                label: intl.formatMessage(messages.filter_budget),
                value: 'budget_iniziale_progetto',
              },
              {
                label: intl.formatMessage(messages.filter_contributo_fc),
                value: 'contributo_deliberato_fc',
              },
              {
                label: intl.formatMessage(messages.sort_data_avvio),
                value: 'data_avvio',
              },
            ]}
            onChange={(v) => {
              setFilters({ ...filters, sort_on: v });
            }}
            aria-controls={results_region_id}
          />
        </div>
        {items?.length > 0 && (
          <>
            <div className="list-items">
              <ProjectsCardListing
                items={
                  items?.length > PAGE_SIZE
                    ? items.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE)
                    : items
                }
                isEditMode={isEditMode}
              />
            </div>
            {items.length > PAGE_SIZE && (
              <div className="list-footer">
                <Pagination
                  activePage={page}
                  totalPages={Math.ceil(items.length / PAGE_SIZE)}
                  onPageChange={handleQueryPaginationChange}
                  firstItem={null}
                  lastItem={null}
                  prevItem={{
                    content: <Icon name={paginationLeftSVG} size="18px" />,
                    icon: true,
                    'aria-disabled': page === 1,
                    className: page === 1 ? 'disabled' : null,
                  }}
                  nextItem={{
                    content: <Icon name={paginationRightSVG} size="18px" />,
                    icon: true,
                    // 'aria-disabled': !this.props.search.batching.next,
                    // className: !this.props.search.batching.next ? 'disabled' : null,
                  }}
                />
              </div>
            )}
          </>
        )}
      </Container>
    </div>
  ) : (
    <></>
  );
};

export default List;
